<div class="photo" [ngClass]="{'editable': editable}" [style.background-image]="photoUrl"></div>
